import styled from "styled-components";
import { theme } from "ui";

type TextHighlightProps = {
  isSelected: boolean;
};

interface BoxColorProps {
  backgroundColor: string;
}

interface ContainerProps {
  hasBackgroundColor?: boolean;
}

export const Container = styled.div<ContainerProps>`
  margin-bottom: 1rem;
  margin-top: 2rem;

  transition: all 0.2s ease-in-out;

  .active {
    border: 2px solid
      ${({ hasBackgroundColor }) =>
        hasBackgroundColor
          ? theme.colors.primary["200"]
          : theme.colors.secondary["250"]};
  }

  .disabled:hover {
    border: 1px solid
      ${({ hasBackgroundColor }) =>
        hasBackgroundColor
          ? theme.colors.primary["200"]
          : theme.colors.secondary["250"]};
    color: ${theme.colors.secondary["250"]};
  }
`;

export const TitleBox = styled.h4`
  color: ${theme.colors.neutral["720"]};
  margin-bottom: 4px;
  text-align: left;
  font-size: 1.15rem;
  line-height: normal;
  font-weight: ${theme.typography.fontWeight["400"]};
  font-family: ${theme.typography.fontFamily.chivo};
`;

export const Attribute = styled.b`
  padding-left: 0.65rem;
  color: ${theme.colors.neutral["750"]};
  line-height: normal;
  font-size: 1.15rem;
  font-weight: ${theme.typography.fontWeight["700"]};
  font-family: ${theme.typography.fontFamily.chivo};
`;

export const BoxOptions = styled.div`
  display: flex;
  gap: 0.8rem;
  flex-wrap: wrap;
  box-sizing: border-box;
  padding-bottom: 0.4rem;
`;

export const BoxTitle = styled.div`
  display: flex;
  margin-bottom: 0.5rem;
  margin-top: 0.5rem;
`;

export const TextTitle = styled.h3`
  font-weight: 200;
  margin-bottom: 0.5rem;
  margin-right: 0.4rem;
`;

export const SubTitle = styled.h3`
  font-weight: ${theme.typography.fontWeight["700"]};
  margin-bottom: 0.5rem;
`;

export const TextHighlight = styled.span<TextHighlightProps>`
  font-weight: 500;
  transition: all 0.2s ease-in-out;
  color: ${({ isSelected }) =>
    isSelected ? theme.colors.secondary["250"] : theme.colors.neutral["330"]};
`;

export const TextSub = styled.span`
  color: ${theme.colors.neutral["400"]};
`;

export const Box = styled.div`
  padding: 0.65rem;
  border-radius: 8px;
  max-width: 10rem;
  max-height: 2.5rem;
  border: 1px solid ${theme.colors.neutral["88"]};

  box-sizing: content-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  cursor: pointer;

  transition: all 0.2s ease-in-out;

  &:hover {
    ${TextHighlight} {
      color: ${theme.colors.secondary["250"]};
    }
  }
`;

export const BoxColor = styled.div<BoxColorProps>`
  border-radius: 50%;
  width: 2.65rem;
  height: 2.65rem;
  max-width: 2.65rem;
  max-height: 2.65rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  cursor: pointer;
  overflow: hidden;
  box-shadow: 0px 1.5px 2px 0px ${theme.colors.neutral["810"]};

  transition: all 0.2s ease-in-out;

  div {
    background: ${theme.colors.primary["25"]};
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: ${({ backgroundColor }) => backgroundColor};
  }
`;
// No momento é necessário utilizar o link padrão (tag a) para que a exibição alternada das cores seja feita da forma correta, pois o Magic Zoom Lib não consegue atualizar a imagem quando a tela permanece estática, o que acontece com o Link (Next) - Wellington.Braga
export const ColorsContainer = styled.a``;
